"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var core_1 = require("@material-ui/core");
var filtersort_icon_svg_1 = __importDefault(require("@assets/components/user/user-link-table/toolbar/filtersort-icon.svg"));
var FilterSortPanel_1 = __importDefault(require("../FilterSortPanel"));
var actions_1 = __importDefault(require("../../../../actions"));
var searchInputHeight_1 = __importDefault(require("./searchInputHeight"));
var LinkIcon_1 = __importDefault(require("../../../../widgets/LinkIcon"));
var TagIcon_1 = __importDefault(require("../../../../widgets/TagIcon"));
var ArrowDownIcon_1 = __importDefault(require("../../../../../app/components/widgets/ArrowDownIcon"));
var SearchIcon_1 = __importDefault(require("../../../../../app/components/widgets/SearchIcon"));
var FilterDrawer_1 = __importDefault(require("../../../../../app/components/FilterDrawer"));
var constants_1 = require("../../../../constants");
var useStyles = core_1.makeStyles(function (theme) {
    var _a, _b, _c;
    return core_1.createStyles({
        root: (_a = {
                display: 'flex',
                height: function (props) { return props.searchInputHeight; },
                flex: 1,
                width: 'unset'
            },
            _a[theme.breakpoints.up('md')] = {
                position: 'relative',
                width: 500,
                flex: '0 1 auto',
            },
            _a),
        searchTextField: (_b = {
                width: '100%',
                height: '100%'
            },
            _b[theme.breakpoints.up('md')] = {
                maxWidth: 500,
            },
            _b),
        searchInput: {
            paddingLeft: theme.spacing(0),
        },
        searchbar: {
            display: 'contents',
        },
        searchInputIcon: {
            marginTop: '4px',
            marginLeft: theme.spacing(1.5),
            marginRight: theme.spacing(1),
        },
        searchContainer: {
            width: '100%',
        },
        filterButton: {
            height: '100%',
            paddingLeft: '30px',
            paddingRight: '30px',
            borderRadius: '0px',
        },
        filterIcon: (_c = {
                paddingLeft: theme.spacing(0.5),
                verticalAlign: 'middle'
            },
            _c[theme.breakpoints.down('sm')] = {
                paddingLeft: theme.spacing(0.0),
            },
            _c),
        buttonWrapper: {
            width: 'auto',
            display: 'inline-flex',
        },
        labelWrapper: {
            verticalAlign: 'middle',
        },
        input: {
            flexGrow: 1,
            height: '100%',
            minHeight: function (props) { return props.textFieldHeight; },
            padding: theme.spacing(0),
            lineHeight: 1.5,
        },
        panelBackdrop: {
            zIndex: 999,
            position: 'fixed',
            height: '100vh',
            width: '100vw',
        },
        filterSortButton: {
            marginRight: '-12px',
        },
    });
});
// Height of the text field in the search input.
var textFieldHeight = searchInputHeight_1.default();
// Search Input field.
var SearchInput = function () {
    var dispatch = react_redux_1.useDispatch();
    var tableConfig = react_redux_1.useSelector(function (state) { return state.user.tableConfig; });
    var isTag = tableConfig.isTag, searchInput = tableConfig.searchInput;
    var searchInputHeight = searchInputHeight_1.default();
    var classes = useStyles({ textFieldHeight: textFieldHeight, searchInputHeight: searchInputHeight });
    var setSearchInput = function (searchInput) {
        var newConfig = { searchInput: searchInput };
        dispatch(actions_1.default.setUrlTableConfig(newConfig));
    };
    var setIsTag = function (isTag) {
        var newConfig = { isTag: isTag };
        dispatch(actions_1.default.setUrlTableConfig(newConfig));
    };
    var applySearch = function () {
        // Only assign either searchText or tags to searchInput after a timeout period
        var newConfig = {
            searchText: isTag ? '' : searchInput,
            tags: isTag ? searchInput : '',
            pageNumber: 0,
        };
        dispatch(actions_1.default.isFetchingUrls(true));
        dispatch(actions_1.default.setUrlTableConfig(newConfig));
        dispatch(actions_1.default.getUrlsForUser());
    };
    react_1.useEffect(function () {
        var timeoutId = setTimeout(function () {
            applySearch();
        }, constants_1.SEARCH_TIMEOUT);
        return function () { return clearTimeout(timeoutId); };
    }, [searchInput]);
    var _a = __read(react_1.useState(false), 2), isSortFilterOpen = _a[0], setIsSortFilterOpen = _a[1];
    var _b = __read(react_1.useState(false), 2), isSearchFilterOpen = _b[0], setIsSearchFilterOpen = _b[1];
    var theme = core_1.useTheme();
    var isMobileView = core_1.useMediaQuery(theme.breakpoints.down('sm'));
    var getSearchLabel = function () {
        if (isMobileView && isTag) {
            return react_1.default.createElement(TagIcon_1.default, { size: 20 });
        }
        if (isMobileView && !isTag) {
            return react_1.default.createElement(LinkIcon_1.default, { size: 20 });
        }
        return (react_1.default.createElement("span", { className: classes.labelWrapper }, isTag ? 'Tag' : 'Link'));
    };
    return (react_1.default.createElement(core_1.ClickAwayListener, { onClickAway: function () {
            setIsSortFilterOpen(false);
            setIsSearchFilterOpen(false);
        } },
        react_1.default.createElement("div", { className: classes.root },
            react_1.default.createElement("div", { className: classes.searchContainer },
                react_1.default.createElement(core_1.TextField, { autoFocus: true, className: classes.searchTextField, variant: "outlined", value: searchInput, onChange: function (e) { return setSearchInput(e.target.value); }, onBlur: function (e) { return setSearchInput(e.target.value); }, onKeyDown: function (e) {
                        var target = e.target;
                        switch (e.key) {
                            case 'Escape':
                                target.value = '';
                                setSearchInput('');
                                break;
                            case 'Enter':
                                break;
                            default:
                                return;
                        }
                        target.blur();
                        e.preventDefault();
                    }, placeholder: isTag ? 'Search tags' : 'Search links', InputProps: {
                        classes: { input: classes.input },
                        className: classes.searchInput,
                        startAdornment: (react_1.default.createElement("div", { className: classes.searchbar },
                            react_1.default.createElement(core_1.Button, { className: classes.filterButton, onClick: function () { return setIsSearchFilterOpen(!isSearchFilterOpen); } },
                                react_1.default.createElement("div", { className: classes.buttonWrapper },
                                    getSearchLabel(),
                                    react_1.default.createElement(ArrowDownIcon_1.default, { className: classes.filterIcon, height: isMobileView ? '20' : '24', width: isMobileView ? '20' : '24' }))),
                            react_1.default.createElement(core_1.Divider, { orientation: "vertical", flexItem: true }),
                            react_1.default.createElement("div", { className: classes.searchInputIcon }, isMobileView ? '' : react_1.default.createElement(SearchIcon_1.default, { size: 16 })))),
                        endAdornment: (react_1.default.createElement(core_1.InputAdornment, { position: "end" },
                            react_1.default.createElement(core_1.IconButton, { className: classes.filterSortButton, onClick: function () { return setIsSortFilterOpen(!isSortFilterOpen); } },
                                react_1.default.createElement("img", { src: filtersort_icon_svg_1.default, alt: "Filter and sort icon" })))),
                    } }),
                react_1.default.createElement(FilterDrawer_1.default, { labels: ['Link', 'Tag'], selectedLabel: isTag ? 'Tag' : 'Link', onClick: function (label) {
                        setIsTag(label === 'Tag');
                        setSearchInput('');
                    }, isFilterOpen: isSearchFilterOpen, isMobileView: isMobileView, setIsFilterOpen: setIsSearchFilterOpen })),
            react_1.default.createElement(FilterSortPanel_1.default, { isOpen: isSortFilterOpen, onClose: function () { return setIsSortFilterOpen(false); }, tableConfig: tableConfig }),
            react_1.default.createElement(core_1.Hidden, { mdUp: true },
                react_1.default.createElement(core_1.Backdrop, { className: classes.panelBackdrop, open: isSortFilterOpen })))));
};
exports.default = SearchInput;
